import { render, staticRenderFns } from "./RegistrationsList.vue?vue&type=template&id=6154446a"
import script from "./RegistrationsList.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationsList.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports